"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuntimeConfig = void 0;
const getRuntimeConfig = (config) => {
    return {
        ...config,
    };
};
exports.getRuntimeConfig = getRuntimeConfig;
